import actionCreator from '@/helpers/redux/actionCreator';

export const SAVE_FORM = '@/SAVE_FORM';

export const saveForm = values => actionCreator(
  SAVE_FORM,
  { values },
);
